import type { Participant } from "../../../types";

export interface StudyDeviceAvailability {
  totalParticipants: number;
  fitbitParticipants: number;
  healthkitParticipants: number;
}

export const DEFAULT_STUDY_DEVICE_AVAILABILITY: StudyDeviceAvailability = {
  totalParticipants: 0,
  fitbitParticipants: 0,
  healthkitParticipants: 0,
};

export function deriveStudyDeviceAvailability(
  participants: Participant[],
): StudyDeviceAvailability {
  const fitbitParticipants = participants.filter((participant: any) => {
    return Boolean(
      participant.fitbitTokens ||
      participant.fitbitUserId ||
      participant.fitbitAccessToken ||
      participant.fitbitData?.accessToken,
    );
  }).length;

  const healthkitParticipants = participants.filter((participant: any) => {
    return Boolean(
      participant.healthkit?.authorized ||
      participant.healthkitConnected ||
      participant.hasValidHealthKit,
    );
  }).length;

  return {
    totalParticipants: participants.length,
    fitbitParticipants,
    healthkitParticipants,
  };
}
